import { useMsal } from "@azure/msal-react";
import { Button, TextField } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import React, { useState } from "react";
import { loginRequest } from "../authConfigFile/authConfig";
import "./Login.css";
import axios from "axios";
import { LOGIN_WITHOUT_SSO } from "../utils/constants";

const Login = () => {
  const { instance } = useMsal();

  const [showSSO, setShowSSO] = useState(true);
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [password, setPassword] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isButtonEnable, setIsButtonEnable] = useState(false);
  const [loginError, setLoginError] = useState("");

  const onClickHandleLoginUsingRedirectHandler = () => {
    localStorage.removeItem("API_TOKEN");
    instance.loginRedirect(loginRequest).catch(console.log);
  };

  const onClickHandleLoginWithoutRedirectHandler = () => {
    if (name.trim() === "" || password === "") {
      if (name.trim() === "") setNameError(true);
      if (password === "") setPasswordError(true);
    } else {
      axios
        .post(
          LOGIN_WITHOUT_SSO,
          {
            username: name,
            password: password,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          localStorage.setItem("API_TOKEN", response?.data?.access);
          localStorage.setItem("REFRESH_TOKEN", response?.data?.refresh);
          setTimeout(function () {
            window.location.href = "/";
          }, 300);
        })
        .catch((error) => {
          if (error?.response?.data?.detail) {
            setLoginError(error?.response?.data?.detail);
            return;
          }
        });
    }
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
    setIsButtonEnable(!isButtonEnable);
  };

  const toggleLoginMethod = () => {
    setShowSSO(!showSSO);
  };

  return (
    <div className="login-bg-image min-h-screen w-full flex justify-center items-center">
      <div className="rounded-2xl shadow-lg bg-white p-8 w-[30rem]">
        <div className="flex flex-col items-center justify-start h-full">
          <div className="flex justify-center items-center mb-8">
            <img
              src={require("../assets/NEW_APP_LOGO.png")}
              alt="logo"
              className="w-[36rem] h-auto"
            />
          </div>
          <div className="rounded-lg shadow-md p-8 bg-[#FAFAFA] flex flex-col items-center sm:items-start gap-4 w-full max-w-full">
            <div
              className="text-2xl mb-4"
              style={{ fontFamily: "Open Sans", fontWeight: 300 }}
            >
              Welcome
            </div>
            <div
              className="text-sm mb-4"
              style={{ fontFamily: "Open Sans", fontWeight: 400 }}
            >
              Login to generate content or request access
            </div>

            {showSSO ? (
              <>
                <Button
                  sx={{
                    size: "1.5rem",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    fontFamily: "Open Sans, sans-serif",
                    backgroundColor: "#EFC634",
                    color: "#4F4830",
                    "&:hover": { backgroundColor: "#FAF0D2" },
                  }}
                  variant="contained"
                  disabled={!isButtonEnable}
                  onClick={onClickHandleLoginUsingRedirectHandler}
                >
                  LOGIN / REQUEST ACCESS (WITH SSO)
                </Button>
                <span
                  className="text-sm mt-4"
                  style={{ fontFamily: "Open Sans", fontWeight: 400 }}
                >
                  OR
                </span>
                <Button
                  sx={{
                    border: "1px solid #EFC634",
                    size: "1.5rem",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    fontFamily: "Open Sans, sans-serif",
                  }}
                  onClick={toggleLoginMethod}
                >
                  Login with Username
                </Button>
              </>
            ) : (
              <>
                <TextField
                  defaultValue=""
                  placeholder="Username"
                  color="tertiary"
                  error={nameError}
                  helperText={nameError && "This field is required"}
                  InputLabelProps={{
                    style: {
                      color: "#828282",
                    },
                  }}
                  focused
                  style={{
                    marginBottom: "2.4rem",
                    width: "100%",
                    height: "16px",
                  }}
                  onChange={(e) => {
                    setName(e.target.value);
                    setNameError(false);
                    setLoginError("");
                  }}
                />
                <TextField
                  defaultValue=""
                  placeholder="Password"
                  color="tertiary"
                  error={passwordError}
                  helperText={passwordError && "This field is required"}
                  InputLabelProps={{
                    style: {
                      color: "#828282",
                    },
                  }}
                  focused
                  type="password"
                  style={{
                    marginBottom: "2.4rem",
                    width: "100%",
                    height: "16px",
                  }}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setPasswordError(false);
                    setLoginError("");
                  }}
                />
                {loginError && (
                  <span className="text-red-500 text-sm -mt-2">
                    {loginError}
                  </span>
                )}
                <Button
                  sx={{
                    size: "1.5rem",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    fontFamily: "Open Sans, sans-serif",
                    backgroundColor: "#EFC634",
                    color: "#4F4830",
                    "&:hover": { backgroundColor: "#FAF0D2" },
                  }}
                  variant="contained"
                  color="secondary"
                  disabled={
                    !(isButtonEnable && name.length > 0 && password.length > 0)
                  }
                  onClick={onClickHandleLoginWithoutRedirectHandler}
                >
                  LOGIN / REQUEST ACCESS (WITHOUT SSO)
                </Button>
                <span
                  className="text-sm mt-4"
                  style={{ fontFamily: "Open Sans", fontWeight: 400 }}
                >
                  OR
                </span>
                <Button
                  sx={{
                    border: "1px solid #EFC634",
                    size: "1.5rem",
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    fontFamily: "Open Sans, sans-serif",
                  }}
                  onClick={toggleLoginMethod}
                >
                  Login with SSO
                </Button>
              </>
            )}
            <div
              className="text-xs my-4 flex items-center space-x-2"
              style={{ fontFamily: "Open Sans", fontWeight: 400 }}
            >
              <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                sx={{
                  padding: 0,
                  color: "#EFC634",
                  "&.Mui-checked": {
                    color: "#EFC634",
                  },
                }}
              />
              <p>
                This tool is intended for demo purposes only, NOT to be used
                live
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
